package app.nestbridge.feature.invitations.presentation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import app.nestbridge.feature.invitations.model.Invitation
import app.nestbridge.feature.invitations.usecase.FindInvitationByClaimTokenUseCase
import app.nestbridge.feature.invitations.screen.ShowInvitationQRCodeEvent
import app.nestbridge.feature.invitations.screen.ShowInvitationQRCodeScreen
import app.nestbridge.feature.invitations.screen.ShowInvitationQRCodeState
import com.slack.circuit.codegen.annotations.CircuitInject
import com.slack.circuit.runtime.Navigator
import com.slack.circuit.runtime.presenter.Presenter
import kotlinx.coroutines.launch
import app.nestbridge.app.util.launchSafely
import me.tatarka.inject.annotations.Assisted
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope

@CircuitInject(
    screen = ShowInvitationQRCodeScreen::class,
    scope = AppScope::class,
)
@Inject
class ShowInvitationQRCodePresenter(
    @Assisted private val screen: ShowInvitationQRCodeScreen,
    @Assisted private val navigator: Navigator,
    private val findInvitationByClaimTokenUseCase: FindInvitationByClaimTokenUseCase,
) : Presenter<ShowInvitationQRCodeState> {

    @Composable
    override fun present(): ShowInvitationQRCodeState {
        var invitation by remember { mutableStateOf(Invitation.empty) }
        var isLoading by remember { mutableStateOf(true) }

        suspend fun loadInvitation() {
            isLoading = true
            invitation = findInvitationByClaimTokenUseCase(screen.invitationId).getOrNull()
                ?: error("Missing invitation for ${screen.invitationId}")
            isLoading = false
        }

        fun onEvent(event: ShowInvitationQRCodeEvent) {
            when (event) {
                ShowInvitationQRCodeEvent.OnAppear -> {
                    kotlinx.coroutines.MainScope().launchSafely(onError = { isLoading = false }) {
                        loadInvitation()
                    }
                }

                ShowInvitationQRCodeEvent.Done -> navigator.pop()
            }
        }

        return ShowInvitationQRCodeState(
            invitation = invitation,
            isLoading = isLoading,
            eventSink = ::onEvent,
        )
    }
}
